/** Extract file extension, ignoring parenthetical suffixes like "(pages 141-530)". */
export function getFileExtension(filename: string): string {
  const cleaned = filename.replace(/\s*\(.*\)\s*$/, '');
  return cleaned.split('.').pop()?.toLowerCase() || '';
}
